module.exports = __webpack_public_path__ + "static/media/fullLogo.11076e32.svg";